import { useMutation, useQueryClient } from '@tanstack/react-query';
import { regionsApi } from '../api/regions.api';
import type { CreateRegionRequest } from '../types/regions.types';
import { isRegionHierarchyQuery } from './isRegionHierarchyQuery';
import { regionKeys } from './queryKeys';

export const useCreateRegion = () => {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: (data: CreateRegionRequest) => regionsApi.createRegion(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: regionKeys.lists() });
      queryClient.invalidateQueries({ queryKey: regionKeys.tree() });
      queryClient.invalidateQueries({ queryKey: regionKeys.byCountryAndTypeAll() });
      // Also invalidate RegionHierarchyInput's own cache — the parent-region picker
      // actually used in production, keyed independently of regionKeys (see
      // isRegionHierarchyQuery.ts for why a predicate is needed here).
      queryClient.invalidateQueries({ predicate: isRegionHierarchyQuery });
    },
  });

  return {
    createRegion: mutation.mutate,
    isCreating: mutation.isPending,
    isSuccess: mutation.isSuccess,
  };
};
